__turbopack_context__.v({
  "className": "inter_21e52e44-module__pEzbzG__className",
});
